import { render, staticRenderFns } from "./estatisticas-revendedores.vue?vue&type=template&id=0433f357&scoped=true"
import script from "./estatisticas-revendedores.vue?vue&type=script&lang=js"
export * from "./estatisticas-revendedores.vue?vue&type=script&lang=js"
import style0 from "./estatisticas-revendedores.vue?vue&type=style&index=0&id=0433f357&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0433f357",
  null
  
)

export default component.exports